const REPORTS_ROUTES = {
  path: '/reports',
  component: () => import('@/pages/Reports/ReportsPagesContainer.vue'),
  children: [
    {
      path: '',
      name: 'reports.index',
      component: () => import('@/pages/Reports/ReportsPage.vue'),
    },
  ],
};

export default REPORTS_ROUTES;
